import { createContext, useContext } from 'react';
import type { Citation, ReasoningQuality } from '../../../services/api';

export interface ExtendedMessage {
  id: string;
  role: 'user' | 'assistant';
  fullContent: string;
  displayedContent: string;
  citations?: Citation[];
  followUpQuestions?: string[];
  confidence?: number;
  reasoningQuality?: ReasoningQuality;
  queryId?: string | null;
  isStreaming: boolean;
}

interface MinervaContextValue {
  extMessages: ExtendedMessage[];
  subject: string;
  /** Envía un mensaje de texto arbitrario al asistente (usado por los chips de follow-up). */
  ask: (text: string) => void;
}

export const MinervaContext = createContext<MinervaContextValue>({
  extMessages: [],
  subject: '',
  ask: () => {},
});

export function useMinervaContext() {
  return useContext(MinervaContext);
}
